import { useEffect, useState } from 'react';

export default function TaskBar() {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    let timer = setInterval(() => setDate(new Date()), 1000);
    return function cleanup() {
      clearInterval(timer);
    };
  }, []);

  return (
    <footer className="taskbar taskbarDisplay">
      <div className="d-flex align-items-center ps-2 pe-3 py-1 justify-content-between">
        <img
          src="/images/desktop_logo.png"
          alt=""
          style={{ width: '30px', height: '30px' }}
        />
        <div className="d-flex align-items-center">
          <i className="bx bx-bluetooth mx-2"></i>
          <i className="bx bx-wifi me-2"></i>
          <i className="bx bxs-volume-full me-2"></i>
          <span>
            {date.getHours()}:
            {date.getMinutes() < 10
              ? `0${date.getMinutes()}`
              : date.getMinutes()}
          </span>
        </div>
      </div>
    </footer>
  );
}
